import React, { Component } from 'react'
import { connect } from 'react-redux'
import SearchWidget from 'components/SearchWidget'

const HomePeopleExtraNav = ({ dispatch }) => {
  return (
    <SearchWidget
      onSearch={s => {
        dispatch({
          type: 'home/people',
          payload: {
            search: s
          }
        })
      }}
      onCancelSearch={() => {
        dispatch({
          type: 'home/people',
          payload: {}
        })
      }}
    />
  )
}

const mapStateToProps = ({ location: { type } }) => ({ place: type })
const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(HomePeopleExtraNav)
